import React from 'react';
import PropTypes from 'prop-types';
import AuthorDateTimeComments from 'src/components/AuthorDateTimeComments';

function Notes({ claim }) {
  const comments = claim.notes
    .filter(note => note.isInternalNote === false)
    .map(note => {
      const { notes, dateCreated, ...rest } = note;
      return {
        ...rest,
        message: notes,
        commentType: null,
        createdDate: dateCreated
      };
    });
  return <AuthorDateTimeComments comments={comments} />;
}

Notes.propTypes = {
  claim: PropTypes.object.isRequired
};

Notes.defaultProps = {};

export default Notes;
